import Quill from 'quill/core';
import ChildHistory from '../../utils/ChildHistory';

const Theme = Quill.import('core/theme');

// @ts-expect-error
class TableCellEditorTheme extends Theme {
  declare quill: Quill;

  addModule(name: string) {
    if (name === 'history') {
      const history = new ChildHistory(this.quill, {
        // @ts-expect-error
        parentQuill: this.options.modules.history.parentQuill,
      });
      // @ts-expect-error
      this.modules[name] = history;
      return history;
    }

    return super.addModule(name);
  }
}

export default TableCellEditorTheme;
